import InMemoryTable from 'libs/kd_data_table/in-memory-table';
export default class ReportPreviewTable extends InMemoryTable {
  constructor(mappedRows, userFieldMappings) {
    console.log('Initializing ReportPreviewTable');
    const tableColumns = _.map(userFieldMappings, function(field) {
      const column = {
        name: field.label(),
        property: field.label(),
        salesforceFieldName: field.salesforce_field_name()
      };
      return column;
    });

    let options = {
      dataset_name: 'report_rows',
      table_properties: {
        name: 'ReportPreviewTable',
        creatable: { enabled: false },
        paginatable: { enabled: true },
        searchable: { enabled: true }
      },
      columns: tableColumns,
      column_properties: {
        sortable: { enabled: true },
        editable: { enabled: false },
        hideable: { enabled: false }
      },
      row_properties: {
        removable: { enabled: false },
        draggable: { enabled: false }
      }
    };

    const el = document.getElementById('js-import-preview-table');

    const data = {
      report_rows: mappedRows,
      first_page: true,
      last_page: false,
      total_report_rows: mappedRows.length
    };
    super(data, el, options);
  }

  updateData(data) {
    let mapped_rows = ko.mapping.fromJS(ko.mapping.fromJS(data), this.row_mapping);
    this.rows(mapped_rows());
    this.updatePagination();
  }
}

